import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation-submenu"
export default class extends Controller {
  static targets = ["modal", "trigger"]

  connect() {
    this.closeWithKeyboard = this.closeWithKeyboard.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeWithKeyboard)
    this.unlockBody()
  }

  open(event) {
    event.preventDefault()

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.modalTarget.classList.remove("pointer-events-none")
    this.modalTarget.setAttribute("aria-hidden", "false")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    requestAnimationFrame(() => {
      this.modalTarget.classList.remove("opacity-0")
      this.modalTarget.classList.add("opacity-100")
      this.modalTarget.classList.remove("-translate-x-8")
      this.modalTarget.classList.add("translate-x-0")
    })
    this.lockBody()
    document.addEventListener("keydown", this.closeWithKeyboard)
  }

  close(event) {
    event?.preventDefault()

    this.modalTarget.classList.remove("opacity-100")
    this.modalTarget.classList.add("opacity-0")
    this.modalTarget.classList.remove("translate-x-0")
    this.modalTarget.classList.add("-translate-x-8")
    this.modalTarget.classList.add("pointer-events-none")
    this.modalTarget.setAttribute("aria-hidden", "true")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("keydown", this.closeWithKeyboard)
    window.setTimeout(() => {
      this.modalTarget.classList.add("hidden")
      this.modalTarget.classList.remove("flex")
      this.unlockBody()
      this.triggerTarget.focus()
    }, this.transitionDurationMs())
  }

  closeWithBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close(event)
    }
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }

  lockBody() {
    document.body.classList.add("overflow-hidden")
  }

  unlockBody() {
    if (!document.querySelector('[data-navigation-submenu-target="modal"][aria-hidden="false"]')) {
      document.body.classList.remove("overflow-hidden")
    }
  }

  transitionDurationMs() {
    const durationValue = window.getComputedStyle(this.modalTarget).transitionDuration
    const firstDuration = durationValue.split(",")[0].trim()

    if (firstDuration.endsWith("ms")) {
      const parsedMs = Number.parseFloat(firstDuration)
      return Number.isFinite(parsedMs) ? parsedMs : 200
    }
    if (firstDuration.endsWith("s")) {
      const parsedSeconds = Number.parseFloat(firstDuration)
      return Number.isFinite(parsedSeconds) ? parsedSeconds * 1000 : 200
    }

    return 200
  }
}
